import React from 'react';
import { CreditCardFormWithValues } from './CreditCardForm';
import { FormSection } from 'redux-form';

interface CreditCardFormSectionProps {
    name?: string;
    [key: string]: any;
}

const CreditCardFormSection: React.FC<CreditCardFormSectionProps> = ({ name = 'creditCard', ...rest }) => (
    <FormSection name={name}>
        <CreditCardFormWithValues component="div" {...rest} />
    </FormSection>
);

export default CreditCardFormSection;
